import React from "react";
import ReactDOM from "react-dom";

import "@fontsource/inter/latin-100.css";
import "@fontsource/inter/latin-200.css";
import "@fontsource/inter/latin-300.css";
import "@fontsource/inter/latin-400.css";
import "@fontsource/inter/latin-500.css";
import "@fontsource/inter/latin-600.css";
import "@fontsource/inter/latin-700.css";
import "@fontsource/inter/latin-800.css";
import "@fontsource/inter/latin-900.css";
import "@fontsource/material-icons";

import "./Config";

// Component
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// css
import "./index.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
